import { Col, Row, Container, Modal } from 'react-bootstrap';
import { CustomButton } from '../components/commons/Buttons';

interface ModalProps {
  show: boolean;
  onHide(): void;
}

export const InactivityModal: React.FC<ModalProps> = ({ ...props }: ModalProps): JSX.Element => {
  const handleClose = () => {
    props.onHide();
    return;
  };

  return (
    <Modal {...props} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header className="">
        <Container>
          <Row className="text-ellipsis">
            <Col>
              <h2 id={`#optin`}>Inactivity Timer</h2>
            </Col>
          </Row>
        </Container>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        <div className="container-wrapper" style={{ minHeight: '8rem' }}>
          <Row>
            <Col style={{ marginTop: '2.8rem' }}>
              <i className="fas fa-exclamation-triangle" /> Warning <br /> You're about to be logged
              off in less than 2 minutes due to inactivity.
            </Col>
          </Row>
        </div>
        <Row>
          <Col style={{ textAlign: 'right' }}>
            <CustomButton onClick={handleClose}>
              <i className="fa-solid fa-x"></i>
              CLOSE
            </CustomButton>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default InactivityModal;
